import { useIsHeidi2PracticeMaxUpgradeEnabled } from '@/features/flags';
import {
  getNewProductTierProduct,
  useQueryProducts,
} from '@/hooks/query/useQueryProducts';
import { BillingSeatType, SubscriptionTier } from '@heidi/schema/ml-scribe';

/**
 * Whether Practice Max can be sold to this viewer: the
 * `release-heidi-2-practice-max-upgrade` flag is on AND the v3 catalogue
 * carries the (CLINICIAN_PRO_PLUS, MAX) row. The backend hides the row until an
 * environment is provisioned (and for regional billers without the product),
 * so a flag alone is not enough — with no row there is no price to check out
 * and the Practice Max entries stay hidden.
 */
export function useIsPracticeMaxUpgradeAvailable() {
  const isPracticeMaxUpgradeEnabled = useIsHeidi2PracticeMaxUpgradeEnabled();
  const { data: products, catalogueVersion } = useQueryProducts({
    heidi2Catalogue: true,
  });
  const practiceMaxProduct =
    catalogueVersion === 'v3'
      ? getNewProductTierProduct(
          SubscriptionTier.CLINICIAN_PRO_PLUS,
          products,
          BillingSeatType.MAX
        )
      : undefined;
  const hasPracticeMaxProduct = practiceMaxProduct != null;

  return {
    isPracticeMaxUpgradeEnabled,
    hasPracticeMaxProduct,
    isPracticeMaxUpgradeAvailable: isPracticeMaxUpgradeEnabled && hasPracticeMaxProduct,
  };
}
